import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../TextBlock'

import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { TextBlock } from '../TextBlock'
import { TextBlockRowGap } from '../TextBlock.h'

export interface ITextBlockPopupNewCard extends ITextBlockProps {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockPopupNewCard = ({
  title,
  description,
  rowGap = TextBlockRowGap.INDENT_0,
  ...rest
}: ITextBlockPopupNewCard): JSX.Element => {
  return (
    <TextBlock rowGap={rowGap} {...rest}>
      <TextBox
        maxLines={1}
        font={TextBoxTypes.Footnote5}
        color={TextBoxColors.TEXT_ICON_PRIMARY}
        title={title}
      />
      <TextBox
        maxLines={1}
        font={TextBoxTypes.Caption4}
        color={TextBoxColors.TEXT_ICON_SECONDARY}
        title={description}
      />
    </TextBlock>
  )
}
